<!-- SIDEBAR CONTENT -->
<div class="content" fusePerfectScrollbar [@animate]="{value:'*',params:{y:'50px'}}">

    <div class="p-24">
        <button mat-raised-button
                class="mat-accent add-todo-button w-100-p"
                (click)="newSupplierOrder()"
                aria-label="Add delivery">
            {{'Add delivery'|translate}}
        </button>
    </div>

    <div class="nav material2">
        <div class="nav-item">
            <a class="nav-link" matRipple [routerLink]="'/supplier-orders'" [routerLinkActive]="[]">
                <mat-icon class="nav-link-icon">local_shipping</mat-icon>
                <span>{{'Delivery history'|translate}}</span>
            </a>
        </div>

        <div class="nav-item">
            <a class="nav-link" matRipple [routerLink]="'/suppliers'" [routerLinkActive]="[]">
                <mat-icon class="nav-link-icon">commute</mat-icon>
                <span>{{'Suppliers'|translate}}</span>
            </a>
        </div>

        <div class="nav-item">
            <a class="nav-link" matRipple [routerLink]="'/manufacturers'" [routerLinkActive]="[]">
                <mat-icon class="nav-link-icon">location_city</mat-icon>
                <span>{{'Manufacturers'|translate}}</span>
            </a>
        </div>
    </div>

</div>
<!-- / SIDEBAR CONTENT -->
